import {StateData} from "../models/platform.model";

export abstract class CommandBase {
    abstract execute(data: StateData): boolean;
}